var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxGender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "e1ee392b-1456-4624-8d4a-98c2a66b2ae6",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "b6b09184-c687-45aa-ab62-737d9b501275",
    "data-name": "Path 12",
    d: "M13.347,6.865A3.6,3.6,0,0,1,10,10.665a3.6,3.6,0,0,1-3.347-3.8A3.6,3.6,0,0,1,10,3.065a3.6,3.6,0,0,1,3.348,3.8",
    style: {
      fill: "#0cba00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab5312f1-dbd7-4cb4-be07-a345c3f18ae6",
    "data-name": "Path 13",
    d: "M10,16.352a27.922,27.922,0,0,1,5.686.583C14.7,14.2,12.527,12.3,10,12.3s-4.7,1.9-5.686,4.631A27.922,27.922,0,0,1,10,16.352",
    style: {
      fill: "#0cba00"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxGender);
export default __webpack_public_path__ + "static/media/bxGender.98d88e8fb9b814ed393aabfaff6bf8ec.svg";
export { ForwardRef as ReactComponent };